export default __webpack_public_path__ + "static/media/9.4ec9a1c1.webp";